import { AuthUser } from '@/core/Auth'

export const Types = {
  STORE_AUTH_USER: 'auth/store_auth_user',
  STORE_AUTH_LOGOUT: 'auth/store_auth_logout',
  STORE_AUTH_UPDATE_POINT: 'auth/store_auth_update_point',
  STORE_AUTH_EMAIL_VERIFIED: 'auth/store_auth_email_verified',
}

declare interface FluxStandardAction {
  readonly type: string
  payload?: any
}

export class StoreAuthUser implements FluxStandardAction {
  type = Types.STORE_AUTH_USER
  constructor(public payload: AuthUser) {}
}

export class StoreAuthLogout implements FluxStandardAction {
  type = Types.STORE_AUTH_LOGOUT
  constructor() {}
}

export class StoreAuthPointUpdate implements FluxStandardAction {
  type = Types.STORE_AUTH_UPDATE_POINT
  constructor(public payload: { point: number }) {}
}

export class StoreAuthEmailVerified implements FluxStandardAction {
  type = Types.STORE_AUTH_EMAIL_VERIFIED
  constructor(public payload: { emailVerifiedAt: string }) {}
}
